import { cn } from '../lib/utils'
import { getRankingFromStorage } from '../storage'
import { secondsToMinutes } from '../utils/format-time'

export function RankingTable() {
	const rankings = getRankingFromStorage()

	return (
		<div
			className={cn('relative aspect-square h-[100%] bg-no-repeat lg:h-[80%]')}
			style={{
				backgroundImage: `url("./assets/tabela-ranking.png")`,
				backgroundSize: 'contain',
				backgroundPosition: 'center',
			}}
		>
			<div className="absolute top-[35%] right-[2%] left-[2%] h-[50%] overflow-y-auto">
				{rankings.length > 0 ? (
					<table className="w-full text-black text-xs lg:text-base">
						<thead>
							<tr className="border-white/30 border-b-2">
								<th className="px-1 py-2 text-left font-bold">#</th>
								<th className="px-1 py-2 text-left font-bold">Nome</th>
								<th className="px-1 py-2 text-center font-bold">Tempo</th>
								<th className="px-1 py-2 text-center font-bold">Data</th>
								<th className="px-1 py-2 text-right font-bold">Pontos</th>
							</tr>
						</thead>
						<tbody className="last:border-b-0">
							{rankings.map((rank, index) => (
								<tr key={`${rank.name}-${rank.date}`} className="border-black/20 border-b">
									<td className="p-1 font-semibold">
										{index + 1}
										{index === 0 && ' 🥇'}
										{index === 1 && ' 🥈'}
										{index === 2 && ' 🥉'}
									</td>
									<td className="max-w-16 truncate p-1">{rank.name}</td>
									<td className="p-1 text-center">{secondsToMinutes(rank.matchTime)}</td>
									<td className="p-1 text-center">{rank.date}</td>
									<td className="p-1 text-right font-bold text-green-600">{rank.score}</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div className="py-8 text-center">
						<p className="text-lg">Nenhum ranking ainda</p>
						<p className="mt-2 text-sm">Seja o primeiro a jogar!</p>
					</div>
				)}
			</div>
		</div>
	)
}
